import React, { useCallback, useState } from 'react';
import { AppModal, AppRemixIcon } from '@/layout/AppComponents';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import ReactDOMServer from 'react-dom/server';
import { axiosPath } from '../../../../../routing/helpers/router';
import colors from '../../../../../constants/colors';
import errorHandler from '@/layout/components/error/ErrorHandler';
import * as currentPageAction from '../../../../../store/actions/currentPageAction';
import Translator from '../../../../components/helpers/Translator';

export default function ResetAllPrevisions({ resourceObligation, elementID }) {
  const { moduleBridgeHex } = useParams();
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const [existingEvidences, setExistingEvidences] = useState(0);

  const checkForEvidences = useCallback(() => {
    setExistingEvidences(
      resourceObligation?.previsions?.filter((pr) => pr.evidence !== null)
        .length
    );
    setShowModal(true);
  }, [resourceObligation]);

  // > RESET PREVISIONS
  const resetPrevisions = useCallback(
    async () =>
      axios
        .post(
          axiosPath(
            "api_r_user_module_resourceManager_resourceObligation_prevision_reset"
          ),
          {
            moduleBridgeHex,
            resourceObligationID: resourceObligation?.id,
          }
        )
        .then(() => {
          setShowModal(false);
          dispatch(currentPageAction.change("updateCard", elementID, true));
          dispatch(
            currentPageAction.change(
              "updateResourceObligationTab",
              elementID,
              true
            )
          );
        })
        .catch((e) => dispatch(errorHandler(e))),
    [moduleBridgeHex, resourceObligation]
  );
  // < RESET PREVISIONS

  return (
    <>
      <AppRemixIcon
        icon="delete-bin"
        color={colors.danger}
        onClick={() => checkForEvidences()}
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-resourceManager"
            name="resource.reset.all.periods"
          />
        )}
        className="pointer"
      />
      <AppModal
        title={
          <Translator
            file="module-resourceManager"
            name="resource.reset.all.periods"
          />
        }
        show={showModal}
        onClose={() => setShowModal(false)}
      >
        {existingEvidences > 0 && (
          <div className="alert alert-danger">
            <Translator
              file="module-resourceManager"
              name="resource.not.restart.periods.associated.evidence"
            />
            .
          </div>
        )}
        <p>
          <Translator
            file="module-resourceManager"
            name="resource.want.delete.all.periods"
          />
          <br />
          <br />
          <Translator
            file="module-resourceManager"
            name="resource.action.cannot.undone"
          />
          .
        </p>
        <button
          type="button"
          className="btn btn-danger"
          disabled={existingEvidences > 0}
          onClick={() => existingEvidences === 0 && resetPrevisions()}
        >
          <Translator file="module-resourceManager" name="resource.restart" />
        </button>
      </AppModal>
    </>
  );
}
